import { render, staticRenderFns } from "./LatestProjects.vue?vue&type=template&id=e7b0b23c&"
import script from "./LatestProjects.vue?vue&type=script&lang=js&"
export * from "./LatestProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports